import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthUserService } from '../../services/auth-user-service/auth-user.service';
import { TokenStorageService } from '../../services/auth-user-service/token-storage.service';

@Component({
  selector: 'mcrit-gestio-authzone-side-menu',
  templateUrl: './authzone-side-menu.component.html',
  styleUrls: ['./authzone-side-menu.component.css']
})
export class AuthzoneSideMenuComponent implements OnInit, OnDestroy {
  private rol: number = 0;
  public links: Array<{ target: string, icon: string, description: string }>;

  private unsubscriber: Subject<void> = new Subject<void>();

  private buildLinks(): void {
    this.links = [
      { target: '/dashboard', icon: 'home', description: this.translate.instant('sideMenu.inici') },
      { target: '/dedicacions', icon: 'drag_indicator', description: this.translate.instant('dedicacions.titol') },
      { target: '/quefaig', icon: 'view_in_ar', description: this.translate.instant('notes.titol') },
      { target: '/oportunitats', icon: 'touch_app', description: this.translate.instant('notes.oportunitats') },
      { target: '/proposalpe', icon: 'view_list', description: this.translate.instant('projectsList.titols.manifestacions') },
      { target: '/proposals', icon: 'view_module', description: this.translate.instant('projectsList.titols.propostes') },
      { target: '/projects', icon: 'view_week', description: this.translate.instant('projectsList.titols.treballs') },
      { target: '/seguimenttecnic', icon: 'bookmarks', description: this.translate.instant('sideMenu.seguimentTreballs') },
      { target: '/invoiceslist', icon: 'payment', description: this.translate.instant('facturesList.title') },
      { target: '/invoicesreblist', icon: 'redeem', description: this.translate.instant('facturesRebList.title') },
      { target: '/utes', icon: 'zoom_in_map', description: this.translate.instant('sideMenu.utesLabel') },
      { target: '/solvencies', icon: 'expand_circle_down', description: this.translate.instant('concursos.titol') },
      { target: '/clientssocislist', icon: 'people', description: this.translate.instant('sideMenu.clientsSocis') },
      { target: '/contactes', icon: 'contacts', description: this.translate.instant('sideMenu.contactes') },
      { target: '/documents', icon: 'library_books', description: this.translate.instant('documents.titol') },
      { target: '/users', icon: 'person', description: this.translate.instant('usuaris.titol') },
      { target: '/login', icon: 'login', description: this.translate.instant('login.subtitol') }
    ];

    if (!(this.rol == 2 || this.rol == 4 || this.rol == 1)) { //2 admin 4 coordinador 1 visor
      let i = this.links.findIndex(item => item.target === '/invoiceslist');
      if (i != -1) this.links.splice(i, 1);
      i = this.links.findIndex(item => item.target === '/invoicesreblist');
      if (i != -1) this.links.splice(i, 1);
    }
    if (this.authUserService.canReport()) {
      this.links.push({ target: '/reports', icon: 'assessment', description: this.translate.instant('sideMenu.informes') });
    }
  }

  public logOut() {
    this.authUserService.logout();
  }

  constructor(private authUserService: AuthUserService, private tokenStorage: TokenStorageService, private translate: TranslateService) {
    this.rol = this.tokenStorage.getRol();
    this.buildLinks();
  }

  ngOnInit() {
    // Si l'usuari canvia d'idioma en calent, reconstruïm les etiquetes del menú
    this.translate.onLangChange
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(() => this.buildLinks());
  }

  ngOnDestroy() {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
